import React, { useState } from "react";

import OrderForm from './orderForm.js';
import Payment from './payment.js';

export default function OrderDetail() {

    return  <OrderForm />;
}